<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Analisis de cotizaciones</h4>
            </div>
            <br>
            <div class="card-body">
                <form class="form-horizontal">
                    <div class="form-body">
                        <h3 class="box-title">Información Básica del cliente</h3>

                        <hr class="m-t-0 m-b-40">
                        <!-- Información básica del cliente -->
                        <!-- ========================== -->
                        <div style="float: right;">
                            <button type="button" class="btn btn-circle btn-facebook btn-lg" (click)="imprimir()"><i class="mdi mdi-printer"></i></button>
                        </div>
                        <div class="col-md-12 col-xl-6 float-left">
                            <div class="col-md-6">
                                <label>Cliente: </label>
                                <input class="form-control" name="elCliente" [(ngModel)]="formCliente">
                            </div>
                            <div class="col-md-6">
                                <label>Contacto: </label>
                                <input class="form-control" name="elContacto" [(ngModel)]="formContacto">
                            </div>
                            <div class="col-md-6">
                                <label>Nombre de la obra: </label>
                                <input class="form-control" name="descrip" [(ngModel)]="formDescripcion">
                            </div>
                            <div class="col-md-6">
                                <label>Teléfono: </label>
                                <input class="form-control" name="laFecha" [dropSpecialCharacters]="true" mask="(00) 000000-000000" [(ngModel)]="formTelefono">
                            </div>
                            <div class="col-md-6">
                                <label>Celular: </label>
                                <input class="form-control" name="elCel" [dropSpecialCharacters]="true" mask="(00) 000000-000000" [(ngModel)]="formCelular">
                            </div>
                            <div class="col-md-6">
                                <label>Email: </label>
                                <input class="form-control" name="elEmail" [(ngModel)]="formEmail">
                            </div>
                            <div class="col-md-12">
                                <label class="col-md-6">Fecha: <h3>{{fechaCotizacion}}</h3> </label>
                            </div>
                            <div class="col-md-12" id="divSelector">
                                <label>Tipo de cotización</label>
                                <select *ngIf="!banderaTipoCotizacion; else folioParpadea" class="form-control" [(ngModel)]="ordenTipo" name="ordenTipo" style="width: 160px" (ngModelChange)="cambiarRojito()">
                                    <!-- (ngModelChange)="recorridoMaterial()" -->
                                    <!--  (click)="tipoOrden()" -->
                                    <!--
                                    <option [value]="selectTC" *ngFor="let selectTC of selectTipoCotizacion">{{ selectTC }}</option>
                                    -->
                                    <option selected="true" value="Montaje">{{ selectMontaje }}</option>
                                    <option value="Venta">{{ selectVenta }}</option>
                                    <option value="Renta">{{ selectRenta }}</option>
                                </select>
                            </div>
                            <ng-template #folioParpadea>
                                <select class="afContrato folioDelContrato form-control" [(ngModel)]="ordenTipo" name="ordenTipo" style="width: 160px" (ngModelChange)="cambiarRojito()">
                                    <!-- (ngModelChange)="recorridoMaterial()" -->
                                    <!--  (click)="tipoOrden()" -->
                                    <!--
                                    <option [value]="selectTC" *ngFor="let selectTC of selectTipoCotizacion">{{ selectTC }}</option>
                                    -->
                                    <option value="Montaje">{{ selectMontaje }}</option>
                                    <option value="Venta">{{ selectVenta }}</option>
                                    <option value="Renta">{{ selectRenta }}</option>
                                </select>
                            </ng-template>
                            <div *ngIf="ordenTipo === 'Renta' || ordenTipo === 'Venta'">
                                <label>Ahora selecciona si la venta va con flete o sin el</label>
                                <select class="form-control" style="width: 160px" name="conFletes" [(ngModel)]="conFlete" (ngModelChange)="generarFlete()">
                                <!-- (ngModelChange)="recorridoMaterial()" -->
                                <!--  (click)="tipoOrden()" -->
                                <!--
                                <option [value]="selectTC" *ngFor="let selectTC of selectTipoCotizacion">{{ selectTC }}</option>
                                -->
                                <option selected= true value= 'false'>Con Flete</option>
                                <option value= 'true'>Sin Flete</option>
                            </select>
                            </div>

                        </div>
                        <div class="col-md-12 col-xl-6 float-right">
                            <div class="col-md-6">
                                <label>Dirección de la obra: </label>
                                <input class="form-control" style="width:400px;" id="DIRECCIONDELAOBRA" name="obraCotizadaa" [(ngModel)]="formObra" />
                                <br>
                                <br/>
                                <!-- PARA PODER UTILIZAR MACHINE ROUTE PARA EL MAPA -->
                                <input type="hidden" id="latitud" />
                                <input type="hidden" id="longitud" />
                                <input type="hidden" id="distanciaM" />
                                <input type="hidden" id="latitudDeSucursal" [(ngModel)]="sucursalLatitud" name="sucLat" />
                                <input type="hidden" id="longitudDeSucursal" [(ngModel)]="sucursalLongitud" name="sucLon" />
                                <!-- PARA PODER UTILIZAR MACHINE ROUTE PARA EL MAPA -->
                                <datalist id="datalista">
                                    <option *ngFor="let lista of resultados" data-value="{{lista.x}}" value="{{lista.label}}"></option>
                                </datalist>
                                <!-- <button (click)="abrirMap()">abrir mapa</button> -->
                                <div id="map" style="height:350px;width: 400px;"></div>
                                <p style="width:400px;">Para usar el mapa haz click derecho para insertar un marcador</p>
                                <br>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <!-- ================================= -->
                            <!-- ========= JUSTIFICACIÓN ========= -->
                            <!-- ================================= -->
                            <!-- Botón justificación -->
                            <!--
                            <div *ngIf="btnJustificacion; else noJustificacion">
                                <br>
                                <a class="btn btn-primary" data-toggle="collapse" href="#collapseJustifi" role="button" aria-expanded="false" aria-controls="collapseExample">
                                    Justificación
                                </a>
                                <br>
                            </div>
                            -->
                            <!-- Botón justificación -->
                            <!-- Textarea -->
                            <!--
                            <div class="collapse col-md-12 col-lg-12" id="collapseJustifi">
                                <div class="col-md-12 col-lg-12">
                                    <br>
                                    <textarea class="form-control col-md-12 col-lg-12" rows="4" placeholder="Justificación..." [(ngModel)]="formJustificacion" name="formJustificacion"></textarea>
                                </div>
                            </div>
                            <div>
                                <ng-template #noJustificacion>
                                </ng-template>
                            </div>
                            -->
                            <!-- Textarea -->
                            <!-- ================================= -->
                            <!-- ========= JUSTIFICACIÓN ========= -->
                            <!-- ================================= -->
                            <br>
                            <hr class="m-t-0 m-b-40">
                            <!-- ============================== -->
                            <!-- BUSCAR MATERIALES EN DATATABLE -->
                            <!-- ============================== -->
                            <h3>Lista de materiales para agregar: </h3>
                            <!-- 
                                <button type="button" class="btn btnCambioListaPrecios float float-right">Cambio de lista de precios</button>
                             -->
                            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                                <thead>
                                    <tr class="altoTablas">
                                        <th>Código</th>
                                        <th>Familia</th>
                                        <th>Descripción</th>
                                        <th>Agregar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="altoTablas" *ngFor="let producto of arrayProductos">
                                        <td>{{ producto.codigo }}</td>
                                        <td>{{ producto.familia }}</td>
                                        <td>{{ producto.descripcion }}</td>
                                        <td>
                                            <button type="button" class="btn btnAgregarProducto altoTablas" (click)="agregarProducto(producto)">Agregar</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- ============================== -->
                            <!-- BUSCAR MATERIALES EN DATATABLE -->
                            <!-- ============================== -->
                        </div>
                        <div class="table-responsive" id="agregarProductosTabla">
                            <br>
                            <hr class="m-t-0 m-b-40">
                            <div class="col-md-12">
                                <label>(%) de aumento en materiales</label>
                                <select class="form-control variosSelect" name="porcentajeA" [(ngModel)]="porcentajeAumento" (ngModelChange)="aumento()" [disabled]="!boolOrdenTipo">
                                    <option [value]="numeroDescuento" *ngFor="let numeroDescuento of numerosDescuento">{{ numeroDescuento }}</option>
                                </select>
                            </div>
                            <br>
                            <hr class="m-t-0 m-b-40">
                            <!-- Agregar los productos a ese dataTable -->
                            <!-- ========================== -->
                            <h3>Materiales agregados: </h3>
                            <table class="table table table-striped table-hover materialesAgregados">
                                <!--  border="1" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="porple-table display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%" -->
                                <thead>
                                    <tr class="altoTablas">
                                        <th></th>
                                        <th style="text-align: center">Código</th>
                                        <th style="text-align: center">Descripción</th>
                                        <th style="text-align: center">Cantidad</th>
                                        <th style="text-align: center">Precio Renta</th>
                                        <th style="text-align: center">Importe</th>
                                        <!--
                                        <th>P.U. venta</th>
                                        <th>Importe Venta</th>
                                        <th>Peso Pieza (Kg)</th>
                                        -->
                                        <th style="text-align: center">Importe peso (Kg)</th>
                                        <th style="text-align: center">Eliminar elemento</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="altoTablas" *ngFor="let producto of material; index as i ">
                                        <td></td>
                                        <td style="text-align: center">{{ producto.codigo }}</td>
                                        <td>{{ producto.descripcion }}</td>
                                        <td class="cantidad altoTablas">
                                            <input id="{{producto.codigo}}" class="form-control" name="{{producto.descripcion}}" (ngModelChange)="calculosProducto(producto)" [(ngModel)]="producto.cantidad" />
                                            <!--
                                            <input (ngModel)="id" (ngModelChange)="calculosProducto(producto)" id="{{producto.codigo}}" type="number" class="form-control" name="pCantidad">
                                            -->
                                        </td>
                                        <td style="text-align: center">{{ producto.precioR }}</td>
                                        <td style="text-align: center">{{ importeRentaImp }}</td>
                                        <!--
                                        <td>{{ producto.precioV }}</td>
                                        <td>{{ producto.importeV }}</td>
                                        <td>{{ producto.peso }}</td>
                                        -->
                                        <td style="text-align: center">{{ importePesoImp }}</td>
                                        <td style="text-align: center">
                                            <a (click)="eliminarMaterial(producto.codigo)">
                                                <i class="fa fa-close text-danger"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <hr class="m-t-0 m-b-40">
                        <div class="col-md-6 col-xl-6 col-sm-6 col-xs-6 float-left">
                            <!-- ================================ -->
                            <!-- ========= MANO DE OBRA ========= -->
                            <!-- ================================ -->
                            <div id="divtituloMano">Mano de Obra (Montadores) <span><i (click)="desplegarManoObra()" style="font-size: 25px" class="mdi {{ iconoMano }} waves-effect waves-dark"></i></span> (desplegable)</div>
                            <div *ngIf="manoDeObraCollapse" id="divManoDeObra">
                                <!-- class="col-6 col-md-6" -->
                                <table id="tablaMano">
                                    <thead>
                                        <tr><br/></tr>
                                        <th class="float-none" colspan="4" style="text-align: center"> Rendimiento (Montaje/Desmontaje)</th>
                                        <tr><br/></tr>
                                        <tr>
                                            <td>Altura:</td>
                                            <td>
                                                <select class="form-control" style="text-align: center; width: 130px" [(ngModel)]="altura" name="altura" (ngModelChange)="generarManoDeObra()">
                                                    <option [value]="aselect" *ngFor="let aselect of alturaSelect">{{ aselect }} metros</option>
                                                </select>
                                                <!--
                                                <input class="camposManoObra form-control" type="number" [(ngModel)]="altura" name="altura" (ngModelChange)="generarManoDeObra()">
                                                -->
                                            </td>
                                            <td></td>
                                            <td>
                                            </td>
                                        </tr>
                                        <tr><br/></tr>
                                        <tr>
                                            <td>Horas Totales: </td>
                                            <td style="color:#000000;"><b>{{ cantidadHorasTotalImp }}</b></td>
                                            <td>Jornales: </td>
                                            <td style="color:#000000;"><b>{{ jornalesImp }}</b></td>
                                        </tr>
                                        <tr><br></tr>

                                    </thead>
                                    <tbody>
                                        <th class="float-none" colspan="4" style="text-align: center"> Variables de Tiempo (horas)</th>
                                        <tr><br/></tr>
                                        <tr style="border-spacing: 4">
                                            <td>Accesos:</td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="Accesos" name="Accesos" (ngModelChange)="variablesTemporales()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} horas</option>
                                                </select>
                                                <!--
                                                <input class="form-control conceptosVarios camposManoObra" type="number" [(ngModel)]="Accesos" name="Accesos" (ngModelChange)="variablesTemporales()" />
                                                -->
                                            </td>
                                            <td>Descargas:</td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="Descargas" name="Descargas" (ngModelChange)="variablesTemporales()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} horas</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Tiempos muertos:</td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="Tiempos" name="Tiempos" (ngModelChange)="variablesTemporales()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} horas</option>
                                                </select>
                                            </td>
                                            <td>Acarreos:</td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="Acarreos" name="Acarreos" (ngModelChange)="variablesTemporales()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} horas</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Tiempos Extras:</td>
                                            <td>
                                                <input class="form-control conceptosVarios camposManoObra" [(ngModel)]="Extras" name="Extras" (ngModelChange)="variablesTemporales()" [dropSpecialCharacters]="true" mask="00" />
                                                <!--
                                                <select class="form-control variosSelect" [(ngModel)]="Extras" name="Extras" (ngModelChange)="variablesTemporales()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} horas</option>
                                                </select>
                                                -->
                                            </td>
                                            <td>Dias Inhabiles:</td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="Inhabiles" name="Inhabiles" (ngModelChange)="variablesTemporales()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} días</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr *ngIf="Inhabiles > 0">
                                            <td></td>
                                            <td></td>
                                            <td>Personas: </td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="personas" name="personas">
                                                    <option [value]="pselect" [selected]="pselect" *ngFor="let pselect of personasSelect">{{ pselect }}</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr><br/></tr>
                                        <th class="float-none" colspan="4" style="text-align: center"> Variables Monetarias ($ pesos)</th>
                                        <tr><br/></tr>
                                        <tr>
                                            <td>Tramites:</td>
                                            <td><input class="form-control conceptosVarios camposManoObra" type="text" mask='00000' [(ngModel)]="Tramites" name="Tramites" (ngModelChange)="sumaConceptosVarios()"></td>
                                            <td>Certificados:</td>
                                            <td><input class="form-control conceptosVarios camposManoObra" type="text" mask='00000' [(ngModel)]="Certificados" name="Certificados" (ngModelChange)="sumaConceptosVarios()"></td>
                                        </tr>
                                        <tr>
                                            <td>Consumibles Especiales:</td>
                                            <td><input class="form-control conceptosVarios camposManoObra" type="text" mask='00000' [(ngModel)]="Gastos" name="Gastos" (ngModelChange)="sumaConceptosVarios()" /></td>
                                            <td> Equipo de seguridad Adicional:</td>
                                            <td><input class="form-control conceptosVarios camposManoObra" type="text" mask='00000' [(ngModel)]="Equipo" name="Equipo" (ngModelChange)="sumaConceptosVarios()" /></td>
                                        </tr>
                                        <tr>
                                            <td> Preparacion material:</td>
                                            <td><input class="form-control conceptosVarios camposManoObra" type="text" mask='00000' [(ngModel)]="Preparacion" name="Preparacion" (ngModelChange)="sumaConceptosVarios()"></td>
                                            <td>Imprevistos:</td>
                                            <td>
                                                <select class="form-control" [(ngModel)]="Imprevistos" name="Imprevistos" style="width: 75px" (ngModelChange)="sumaConceptosVarios()">
                                                    <option value="0" selected>{{ imprevistos0 }}</option>
                                                    <option value="5">{{ imprevistos5 }}</option>
                                                    <option value="10">{{ imprevistos10 }}</option> 
                                                    <option value="15">{{ imprevistos15 }}</option>
                                                    <option value="20">{{ imprevistos20 }}</option>
                                                </select>
                                            </td>
                                            <!--
                                            <td><input class="form-control conceptosVarios camposManoObra" type="number" [(ngModel)]="Imprevistos" name="Imprevistos" (ngModelChange)="sumaConceptosVarios()"></td>
                                            -->
                                        </tr>
                                        <tr>
                                            <td>Comidas</td>
                                            <td><input class="form-control conceptosVarios camposManoObra" type="text" mask='00000' [(ngModel)]="Comidas" name="Comidas" (ngModelChange)="sumaConceptosVarios()"></td>
                                        </tr>
                                        <br><br><br>
                                        <th class="float-none" colspan="4" style="text-align: center">Traslados del Personal (Montadores)</th>
                                        <tr><br/></tr>
                                        <tr style="text-align: center">
                                            <td>Transporte</td>
                                            <td>Costo Unidad</td>
                                            <td>Viajes/persona</td>
                                            <td>Redondo</td>
                                            <td>SubTotal</td>
                                        </tr>
                                        <!--
                                        <tr><br/></tr>    
                                        -->
                                        <tr>
                                            <td>Avion:</td>
                                            <td><input class="form-control camposManoObra" type="number" [(ngModel)]="avionCosto" name="avionCosto" (ngModelChange)="trasladosChallenge()"></td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="avionViajes" name="avionViajes" (ngModelChange)="trasladosChallenge()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                </select>
                                            </td>
                                            <td style="text-align: center"><input type="checkbox" name="avionCheck" [(ngModel)]="avionCheck" id="avionCheck" (ngModelChange)="trasladosChallenge()"></td>
                                            <td>{{sumaAvion}}</td>
                                        </tr>
                                        <tr>
                                            <td>Autobus:</td>
                                            <td><input class="form-control camposManoObra" type="number" [(ngModel)]="autobusCosto" name="autobusCosto" (ngModelChange)="trasladosChallenge()"></td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="autobusViajes" name="autobusViajes" (ngModelChange)="trasladosChallenge()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                </select>
                                            </td>
                                            <td style="text-align: center"><input type="checkbox" name="autobusCheck" [(ngModel)]="autobusCheck" id="autobusCheck" (ngModelChange)="trasladosChallenge()"></td>
                                            <td>{{sumaAutobus}}</td>
                                        </tr>
                                        <tr>
                                            <td>Barco:</td>
                                            <td><input class="form-control camposManoObra" type="number" [(ngModel)]="barcoCosto" name="barcoCosto" (ngModelChange)="trasladosChallenge()"></td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="barcoViajes" name="barcoViajes" (ngModelChange)="trasladosChallenge()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                </select>
                                            </td>
                                            <td style="text-align: center"><input type="checkbox" name="barcoCheck" [(ngModel)]="barcoCheck" id="barcoCheck" (ngModelChange)="trasladosChallenge()"></td>
                                            <td>{{sumaBarco}}</td>
                                        </tr>
                                        <tr>
                                            <td>Taxi:</td>
                                            <td><input class="form-control camposManoObra" type="number" [(ngModel)]="taxiCosto" name="taxiCosto" (ngModelChange)="trasladosChallenge()"></td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="taxiViajes" name="taxiViajes" (ngModelChange)="trasladosChallenge()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                </select>
                                            </td>
                                            <td>{{sumaTaxi}}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Otro:</td>
                                            <td><input class="form-control camposManoObra" type="number" [(ngModel)]="otroCosto" name="otroCosto" (ngModelChange)="trasladosChallenge()"></td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="otroViajes" name="otroViajes" (ngModelChange)="trasladosChallenge()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                </select>
                                            </td>
                                            <td>{{sumaOtro}}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td style="text-align: right">{{sumaTrasladosTotalImp}}</td>
                                        </tr>
                                        <tr><br/></tr>
                                        <tr>
                                            <td>Montaje: </td>
                                            <td style="color:#000000;"><b>{{ montajeImp }}</b></td>
                                            <td></td>
                                            <td>Desmonataje: </td>
                                            <td style="color:#000000;"><b>{{ desmontajeImp }}</b></td>
                                        </tr>
                                        <tr> <br/></tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td>Total:</td>
                                            <td style="color:#000000;"><b>{{totalTotalImp}}</b></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div id="divtituloMano">Mano de Obra (Montadores) <span><i (click)="desplegarManoObra()" style="font-size: 25px" class="mdi {{ iconoMano }} waves-effect waves-dark"></i></span> (desplegable)</div>
                            </div>
                            <!-- ================================ -->
                            <!-- ========= MANO DE OBRA ========= -->
                            <!-- ================================ -->
                            <br>
                            <!-- ========================== -->
                            <!-- ========= FLETES ========= -->
                            <!-- ========================== -->
                            <div>
                                <div id="divtituloFletes">Calculo de Fletes (Operadores) <span><i (click)="desplegarFlete()" style="font-size: 25px" class="mdi {{ iconoFlete }} waves-effect waves-dark"></i></span> (desplegable)</div>
                                <!-- Todo lo que va a esconderse-->
                                <div *ngIf="fletesCollapse" id="divFletes">
                                    <!-- La tabla para gurdar los valores de los gastos vehiculares-->
                                    <br/>
                                    <h3 style="text-align: center">Gastos vehiculares</h3>
                                    <table>
                                        <thead>
                                            <tr>
                                                <td style="text-align: center;" colspan="3" hidden>Gastos Vehiculares</td>
                                            </tr>
                                            <br>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Vehiculo recomendado: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>{{ vehiculoNombre }}</b></td>
                                            </tr>
                                            <tr *ngIf="banderaVehiculo2">
                                                <td>Vehiculo recomendado: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>{{ vehiculo2Nombre }}</b></td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Distancia: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>{{ distancia }} Kilómetros.</b></td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Precio Gasolina: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>${{ vehiculoCombustiblePrecio }} pesos</b></td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Gastos Gasolina: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>${{ gastoCombustibleVistaImp }} pesos</b></td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>casetas: $</td>
                                                <td></td>
                                                <td style="text-align: center">
                                                    <input class="form-control" style="width:70px; text-align: center" type="number" id="casetas" name="casetas" [(ngModel)]="gastoCasetas" (ngModelChange)="generarFlete()">
                                                </td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Imprevistos: </td>
                                                <td></td>
                                                <td style="text-align: center">
                                                    <select class="form-control selectImprevistos" [(ngModel)]="gastoExtra" name="gastoExtra" (ngModelChange)="generarFlete()">
                                                        <option [value]="imprevisto" *ngFor="let imprevisto of imprevistos">${{ imprevisto }} pesos</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Recolección: </td>
                                                <td></td>
                                                <td style="text-align: center"><input type="checkbox" name="checkRecoleccion" id="checkRecoleccion" [(ngModel)]="checkRecoleccion" (ngModelChange)="generarFlete()">
                                                </td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Total: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>${{ operacionTotalVehicularesVista }} pesos</b></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br>
                                    <hr class="mt-5 m-b-40 ">
                                    <!-- La otra tabla para los viaticos de los Operadores-->
                                    <h3 style="text-align: center">Viáticos</h3>
                                    <table>
                                        <thead>
                                            <td style="text-align: center;" colspan="4" hidden>Viaticos</td>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style="text-align: center">Concepto &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;</td>
                                                <td></td>
                                                <td style="text-align: center">costo unitario &nbsp;&nbsp;</td>
                                                <td style="text-align: center">cantidad dias/veces &nbsp;&nbsp;</td>
                                                <td></td>
                                                <td style="text-align: center">Subtotal</td>
                                            </tr>
                                            <tr><br/></tr>
                                            <tr>
                                                <td style="text-align: left">Alojamiento</td>
                                                <td></td>
                                                <td style="text-align: center">{{ alojamientoInput }}</td>
                                                <td style="text-align: center">
                                                    <select class="form-control variosSelect" [(ngModel)]="alojamientoDias" name="alojamientoDias" (ngModelChange)="fletesViaticos()">
                                                        <option [value]="numeroViatico" *ngFor="let numeroViatico of numerosViaticos">{{ numeroViatico }}</option>
                                                        <!--
                                                        <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                        -->
                                                    </select>
                                                </td>
                                                <td></td>
                                                <td style="text-align: center">{{ acarreosTotalImp }}</td>
                                            </tr>
                                            <tr>
                                                <td style="text-align: left">Desayunos</td>
                                                <td></td>
                                                <td style="text-align: center">{{desayunosInput}}</td>
                                                <td style="text-align: center">
                                                    <select class="form-control variosSelect" name="desayunosDias" [(ngModel)]="desayunosDias" (ngModelChange)="fletesViaticos()">
                                                        <option [value]="numeroViatico" *ngFor="let numeroViatico of numerosViaticos">{{ numeroViatico }}</option>
                                                    </select>
                                                </td>
                                                <td></td>
                                                <td style="text-align: center">{{ desayunosTotalImp }}</td>
                                            </tr>
                                            <tr>
                                                <td style="text-align: left">Comidas</td>
                                                <td></td>
                                                <td style="text-align: center">{{comidasInput}}</td>
                                                <td style="text-align: center">
                                                    <select class="form-control variosSelect" name="comidasDias" [(ngModel)]="comidasDias" (ngModelChange)="fletesViaticos()">
                                                        <option [value]="numeroViatico" *ngFor="let numeroViatico of numerosViaticos">{{ numeroViatico }}</option>
                                                    </select>
                                                </td>
                                                <td></td>
                                                <td style="text-align: center">{{ comidasTotalImp }}</td>
                                            </tr>
                                            <tr>
                                                <td style="text-align: left">Cenas</td>
                                                <td></td>
                                                <td style="text-align: center">{{cenasInput}}</td>
                                                <td style="text-align: center">
                                                    <select class="form-control variosSelect" name="cenasDias" [(ngModel)]="cenasDias" (ngModelChange)="fletesViaticos()">
                                                        <option [value]="numeroViatico" *ngFor="let numeroViatico of numerosViaticos">{{ numeroViatico }}</option>
                                                    </select>
                                                </td>
                                                <td></td>
                                                <td style="text-align: center">{{ cenasTotalImp }}</td>
                                            </tr>
                                            <tr style="text-align: center">
                                                <td>Total</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>{{ totalViaticosImp }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br>
                                    <!-- La otra tabla para los viajes del personal-->
                                    <div class="float-center">
                                        <h3>Total fletes: ${{ totalFletesImp }} pesos</h3>
                                    </div>
                                    <div id="divtituloFletes">Calculo de Fletes (Operadores) <span><i (click)="desplegarFlete()" style="font-size: 25px" class="mdi {{ iconoFlete }} waves-effect waves-dark"></i></span> (desplegable)</div>
                                </div>
                            </div>
                            <!-- ========================== -->
                            <!-- ========= FLETES ========= -->
                            <!-- ========================== -->
                            <br>
                        </div>
                        <div class="col-md-6 col-xl-6 float-right">
                            <!-- id="tablaResumenServicio" -->
                            <!-- ==================================== -->
                            <!-- ========= Renta por X días ========= -->
                            <!-- ==================================== -->
                            <table class="display nowrap table">
                                <tbody>
                                    <tr>
                                        <th>Renta diaria: </th>
                                        <th>$ {{ rentaDiariaImp }}</th>
                                    </tr>
                                    <tr>
                                        <th>Renta 7 días: </th>
                                        <th>$ {{ rentaSDiasImp }}</th>
                                    </tr>
                                    <tr>
                                        <th>Renta 15 días: </th>
                                        <th>$ {{ rentaQDiasImp }}</th>
                                    </tr>
                                    <tr>
                                        <th>Renta 30 días: </th>
                                        <th>$ {{ sumaRentaImp }}</th>
                                    </tr>
                                    <tr>
                                        <th>Total de piezas: </th>
                                        <th>{{sumaCantidadImp}}</th>
                                    </tr>
                                    <tr>
                                        <th>Peso total (Kg) : </th>
                                        <th>{{sumaPesoImp}}</th>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- ==================================== -->
                            <!-- ========= Renta por X días ========= -->
                            <!-- ==================================== -->
                            <!-- ================================================= -->
                            <!-- ============== RESUMEN DE SERVICIO ============== -->
                            <!-- ================================================= -->
                            <!-- En Tabla: bgcolor="#bfbfbf" -->
                            <table class="display nowrap table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="float-none tablaResumenServicio" colspan="2" style="text-align: center">Resumen de servicio </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style="text-align: center">
                                        <th>Periodo de alquiler: </th>
                                        <!-- <th>{{contratoFechaInicio}}</th> -->
                                        <th>{{fechaCotizacion}}</th>
                                    </tr>
                                    <tr style="text-align: center">
                                        <th>al: </th>
                                        <th>{{fechaFin}}</th>
                                    </tr>
                                    <tr style="text-align: center">
                                        <th>
                                            Días de renta: &nbsp;
                                            <input class="form-control" type="number" style="width: 60px" id="diasR" name="diasRenta" [disabled]="!boolOrdenTipo" [(ngModel)]="diasDeRenta" (ngModelChange)="renta()">
                                        </th>
                                        <th>Precio: {{ resultadoDiasRentaImp }}</th>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- ================================================= -->
                            <!-- ============== RESUMEN DE SERVICIO ============== -->
                            <!-- ================================================= -->
                            <!-- ====================================== -->
                            <!-- ============== DESGLOSE ============== -->
                            <!-- ====================================== -->
                            <table class="display nowrap table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="tablaDesglose" colspan="4" style="text-align: center">Desglose</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>Alquiler o porroga</th>
                                        <th colspan="3" style="text-align: right">$ {{resultadoPorcentajeDescuento}}</th>
                                        <!-- <th colspan="3" style="text-align: right">$ {{sumaRenta}}</th> -->
                                    </tr>
                                    <tr>
                                        <th>Total Mano de Obra</th>
                                        <th colspan="3" style="text-align: right">
                                            $ {{ totalTotalImp }}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>Fletes</th>
                                        <th colspan="3" style="text-align: right">
                                            $ {{totalFletesImp}}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>Sub-Total sin IVA ({{ formIva }})</th>
                                        <th colspan="3" style="text-align: right">$ {{ subtotalImp }}</th>
                                    </tr>
                                    <tr>
                                        <th>Venta de material/pagaré (con IVA)</th>
                                        <th colspan="3" style="text-align: right">
                                            $ {{ventaTotal}}
                                            <!--
                                            $ {{costoTotal}}
                                            -->
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- ====================================== -->
                            <!-- ============== DESGLOSE ============== -->
                            <!-- ====================================== -->
                        </div>
                        <!-- Costo total -->
                        <div class="col-md-12 float-left">
                            <br>
                            <h2 class="col-md-6 float-left resaltar">Costo total con IVA</h2>
                            <h2 class="col-md-6 float-left resaltar">$ {{costoTotal}}</h2>
                        </div>
                        <!-- Costo total -->
                        <!-- Botones -->
                        <!-- -->
                        <div class="col-md-12 float-left">
                            <hr class="mt-5 m-b-40 ">
                            <div class="form-actions">
                                <div class="col-md-6 float-left">
                                    <button class="btn btn-block boton1" type="button" (click)="controlCotizacion()">Guardar cotización</button>
                                </div>
                                <!--(click)="enviarCotizador()"-->
                                <!--
                                <div class="col-md-6 float-left">
                                    <button class="btn btn-block boton2">Botón 2</button>
                                </div>
                                -->
                            </div>
                        </div>
                        <!-- Botones fin -->
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/cotizador/cotizador.component.html